import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { selectBestPerformingDashboard } from '@epicuro-next/state/analytics-entities';
import { Store } from '@ngrx/store';

@Component({
  selector: 'epc-dashboard-page',
  templateUrl: './dashboard-page.component.html',
  styleUrls: ['./dashboard-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DashboardPageComponent {
  protected location = inject(Location);

  private store = inject(Store);

  public dashboardSettings$ = this.store.select(selectBestPerformingDashboard);
}
